import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getApiInstance } from "./config";
import { ErrorResponsesCreateOrUpdate } from "../types/records.types";
import { MutationOptions } from "../types/mutation.types";
import { useStore } from "../store/store";

export type FileToDelete = {
    id: string | number;
    entity: string;
    instanceToUse?: string;
};

export const useDeleteFile = (options?: MutationOptions, instanceToUse?: string) => {
    const queryClient = useQueryClient();
    const { notifications } = useStore();

    return useMutation<any, ErrorResponsesCreateOrUpdate, FileToDelete, any>({
        mutationFn: (record) => deleteFile(record, instanceToUse),
        onSuccess(data, variables) {
            queryClient.invalidateQueries({
                predicate(query: any) {
                    return query.queryKey[0].startsWith(options?.queryInvalidatePrefix || variables.entity);
                },
            });
            
            if (variables.entity === "directus_users") {
                queryClient.invalidateQueries({
                    queryKey: ["user"],
                });
            }
        },
        onError(error: ErrorResponsesCreateOrUpdate) {
            notifications.setNotification({
                isOpen: true,
                message: error.response.data.errors[0].message,
                severity: "error",
            });
            return error.response.data.errors[0].message;
        },
    });
};

const deleteFile = async (record: FileToDelete, instanceToUse?: string) => {
    const apiInstance = getApiInstance(instanceToUse);
    const deletedRecord = await apiInstance({
        method: "DELETE",
        url: `files/${record.id}`,
    });

    return deletedRecord.data.data;
};
